import React, { forwardRef } from "react";
import { useTranslation } from "react-i18next";

const MapitFileInput = forwardRef(function FileInput(
    {
        name,
        onLoadEnd,
        onLoading,
        onError,
        onChange,
        maxSize = 1,
        accept,
        ...props
    },
    ref
) {

    const { t } = useTranslation();

    function readFileAsync(file) {
        return new Promise((resolve, reject) => {
            let reader = new FileReader();
            reader.onload = () => {
                resolve(reader.result);
            };
            reader.onloadend = () => {
                if (onLoadEnd) {
                    onLoadEnd();
                }
            };
            reader.onerror = reject;
            reader.readAsDataURL(file);
        });
    }

    const fileReadHandler = async (e) => {
        try {
            let files = e.target.files;

            if (files?.length) {
                let currentFile = files[0];

                if (maxSize) {
                    const fileSizeInMB = currentFile.size / 1024 / 1024;
                    if (fileSizeInMB > maxSize) {
                        if (onError) onError(t("form.fileMaxSize", { ns: "public", maxSize }));
                        return;
                    }
                }

                let acceptFileTypes = accept.replace('image/*', 'png,bmp,webp,tiff,svg,icon,jpeg,jpg').replace(/image\//g, '').replace(/application\//g, '').replace(/.\//g, '');
                let type = currentFile.type.split('/')[1];

                if (!(accept.includes("image/*") && currentFile.type.includes("image/")) && !acceptFileTypes.includes(type)) {
                    if (onError) onError(t("form.invalidFileTypeUpload", { ns: "public", acceptFileTypes }));
                    return;
                }

                if (onLoading) {
                    onLoading();
                }

                let base64 = await readFileAsync(currentFile);
                onChange({ target: { name, value: base64 } });
            }
        } catch (error) {
            if (onError) {
                onError(error);
            }
        } finally {
            if (onLoadEnd) {
                onLoadEnd();
            }
        }
    };

    return (
        <input
            name={name}
            hidden
            ref={ref}
            accept={accept}
            multiple
            type="file"
            onChange={fileReadHandler}
            {...props}
        />
    );
});

export default MapitFileInput;
